"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const d3updatePattern_1 = require("../layerstack/d3updatePattern");
class ImageLayer {
    constructor(view, args) {
        this.update = {
            parent: () => this.attach(),
            data: () => this.d3updatePattern.update.data(),
            transformation: () => this.d3updatePattern.update.transformation(),
            style: () => this.d3updatePattern.update.style()
        };
        this.view = view;
        this.args = args;
        this.name = args.name;
    }
    attach() {
        this.d3updatePattern = new d3updatePattern_1.D3UpdatePattern({
            parent: this.view.parent,
            layer: this,
            data: this.args.data,
            name: this.args.name,
            className: 'node',
            elementType: 'image',
            create: s => s.attr('xlink:href', d => this.args.imagehref(d))
                .attr('width', .05)
                .attr('height', .05),
            updateColor: s => { },
            updateTransform: s => s.attr("transform", (d, i, v) => this.args.transform(d, this.args.delta(d, i, v)))
        });
    }
}
exports.ImageLayer = ImageLayer;



//////////////////
// WEBPACK FOOTER
// ./dist/js/components/layers/image-layer.js
// module id = 236
// module chunks = 0